import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

const gatedCommunityPage: FlowPage = {
  slug: () => 'gated-community',
  isEnabled: ({ answers }) => {
    return answers['home.hoa_type']?.['gated_community'];
  },
  title: () => 'Is there a guard or call box at the entrance?',
  subtitle: () => 'A call box is a device that calls the homeowner to access the property.',
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => {
    return [
      {
        key: 'home.hoa_type.guarded_gated_community',
        type: 'radio_single_select',
        options: [
          {
            label: 'Yes',
            value: 'has_guard',
          },
          {
            label: 'No',
            value: 'no_guard',
          },
        ],
      },
    ];
  },
};

export default gatedCommunityPage;
